import { DoqFaceSvgProps } from '../types';

const ReferenceTableError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    className={className}
    viewBox="0 0 320 320"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g clipPath="url(#clip0_2665_52671)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-reference-table-error">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#A3CBF5"
        mask="url(#bottom-mask-reference-table-error)"
      />

      <mask
        id="mask0_2062_29234"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_2062_29234)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#2E0057"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#2E0057"
      />
      <path
        d="M96 243C96 242.448 96.4477 242 97 242H223C223.552 242 224 242.448 224 243V245C224 245.552 223.552 246 223 246H97C96.4477 246 96 245.552 96 245V243Z"
        fill="#4C008F"
        fillOpacity="0.5"
      />
      <path
        d="M96 277C96 276.448 96.4477 276 97 276H223C223.552 276 224 276.448 224 277V279C224 279.552 223.552 280 223 280H97C96.4477 280 96 279.552 96 279V277Z"
        fill="#4C008F"
        fillOpacity="0.5"
      />
      <path
        d="M97 258C96.4477 258 96 258.448 96 259V261C96 261.552 96.4477 262 97 262H223C223.552 262 224 261.552 224 261V259C224 258.448 223.552 258 223 258H97Z"
        fill="#4C008F"
        fillOpacity="0.5"
      />
      <path
        d="M96 293C96 292.448 96.4477 292 97 292H223C223.552 292 224 292.448 224 293V295C224 295.552 223.552 296 223 296H97C96.4477 296 96 295.552 96 295V293Z"
        fill="#4C008F"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159 200C153.078 200 147.907 203.217 145.141 208L150.056 208C152.253 205.545 155.446 204 159 204C162.554 204 165.747 205.545 167.944 208L172.859 208C170.093 203.217 164.922 200 159 200Z"
        fill="#2E0057"
      />
      <path
        d="M284 98.4356C283.159 86.2788 276.356 74.6785 266.155 68.0028L265.5 70.7572C264.41 75.3391 263.321 79.9198 262.234 84.5023C257.953 83.0744 253.029 83.3443 249.173 85.6913C245.319 88.0384 242.757 92.5666 243.216 97.0527C237.855 95.695 231.884 97.0246 227.603 100.524C225.621 102.146 224.032 104.217 222.915 106.52C222.667 106.373 222.403 106.255 222.122 106.174C221.042 105.865 219.872 106.171 218.862 106.663C218.135 107.015 217.46 107.469 216.851 108H210.771C192.762 106.278 133.187 106.279 115.209 108H109.154C108.544 107.468 107.867 107.013 107.138 106.66C106.128 106.168 104.958 105.862 103.878 106.171C103.597 106.252 103.333 106.371 103.085 106.517C101.968 104.215 100.379 102.143 98.3965 100.521C94.1159 97.0218 88.1449 95.6922 82.7843 97.0499C83.2427 92.5638 80.6805 88.0356 76.8274 85.6885C72.9742 83.3415 68.0467 83.0716 63.7661 84.4995L63.1338 81.8403C62.0368 77.2266 60.9401 72.6143 59.8454 68C49.6444 74.6729 42.8409 86.276 42 98.4328C47.296 94.4499 53.2726 91.3692 59.5923 89.3679C58.4729 93.3424 61.2348 97.6429 64.9642 99.4222C68.6936 101.201 73.0727 100.96 77.1171 100.128C77.2084 105.212 81.0516 109.548 85.6976 111.758C82.2136 114.693 80 119.088 80 124V148H120C124.418 148 128 144.418 128 140C128 144.418 131.582 148 136 148H240V124C240 119.857 238.426 116.083 235.843 113.241C236.835 113.025 237.815 112.749 238.778 112.4C244.082 110.48 248.793 105.763 248.894 100.128C252.941 100.963 257.32 101.201 261.047 99.4222C264.774 97.6429 267.536 93.3424 266.419 89.3679C272.73 91.372 278.704 94.4527 284 98.4356Z"
        fill="#500052"
      />
    </g>
    <defs>
      <clipPath id="clip0_2665_52671">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { ReferenceTableError };
